import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip"

interface MyTooltipProps {
    children: React.ReactNode
    text: string
}

export const MyTooltip = ({ children, text }: MyTooltipProps) => {
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger>{children}</TooltipTrigger>
                <TooltipContent>
                    <p className="whitespace-pre-wrap">{text}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    )
}